import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../just.css";
import { reactLocalStorage } from "reactjs-localstorage";
import { connect } from "react-redux";
import { API_BASE_URL } from "../utils/endpoints";
import "react-semantic-toasts/styles/react-semantic-alert.css";

import {
 
  Segment,
 
  Transition,
 
  Label,
  Header,

  Button,
  Icon,
 
  Checkbox,
 
} from "semantic-ui-react";




class VacationLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
   
      Cities: [],
  
      Ajlun: [],
      Amman: [],
      Aqaba: [],
      Balqa: [],
      Irbid: [],
      Jarash: [],
      Karak: [],
      Maan: [],
      Madaba: [],
      Mafraq: [],
      Tafiela: [],
      Zarqa: [],

      Areas:[],

      AjlunAreas:[],
      AmmanAreas:[],
      AqabaAreas:[],
      BalqaAreas:[],
      IrbidAreas:[],
      JarashAreas:[],
      KarakAreas:[],
      MaanAreas:[],
      MadabaAreas:[],
      MafraqAreas:[],
      TafielaAreas:[],
      ZarqaAreas:[],
    

    
      visibleAmman: false,
      visibleIrbid: false,
      visibleJarash: false,
      visibleBalqa: false,
      visibleZarqa: false,
      visibleTafiela: false,
      visibleAjlun: false,
      visibleKarak: false,
      visibleMadaba: false,
      visibleAqaba: false,
      visibleMaan: false,
      visibleMafraq: false,

      visible:false,
      AreaName:'',
    areas:[],
     

    };
  }

  componentDidMount() {
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/general/getProfiledLocationData?collection=governorate&id=";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/general/getProfiledLocationData?collection=governorate&id=";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.data !== undefined) {
        this.setState({ Cities: res.data.result.data });
        reactLocalStorage.set("flag", "work");
      }
    });
  }

  toggleVisibility = (value) => {
    if (value === "Amman") {
      this.setState((prevState) => ({ visibleAmman: !prevState.visibleAmman }));
    }

    if (value === "Ajlun") {
      this.setState((prevState) => ({ visibleAjlun: !prevState.visibleAjlun }));
    }
    if (value === "Aqaba") {
      this.setState((prevState) => ({ visibleAqaba: !prevState.visibleAqaba }));
    }
    if (value === "Balqa") {
      this.setState((prevState) => ({ visibleBalqa: !prevState.visibleBalqa }));
    }
    if (value === "Irbid") {
      this.setState((prevState) => ({ visibleIrbid: !prevState.visibleIrbid }));
    }
    if (value === "Jarash") {
      this.setState((prevState) => ({
        visibleJarash: !prevState.visibleJarash,
      }));
    }
    if (value === "Karak") {
      this.setState((prevState) => ({ visibleKarak: !prevState.visibleKarak }));
    }
    if (value === "Ma'an") {
      this.setState((prevState) => ({ visibleMaan: !prevState.visibleMaan }));
    }
    if (value === "Madaba") {
      this.setState((prevState) => ({
        visibleMadaba: !prevState.visibleMadaba,
      }));
    }
    if (value === "Mafraq") {
      this.setState((prevState) => ({
        visibleMafraq: !prevState.visibleMafraq,
      }));
    }
    if (value === "Tafiela") {
      this.setState((prevState) => ({
        visibleTafiela: !prevState.visibleTafiela,
      }));
    }
    if (value === "Zarqa") {
      this.setState((prevState) => ({ visibleZarqa: !prevState.visibleZarqa }));
    }
  };

  addGover = (event) => {
    
    var value = event.target.value;
    var id = event.target.id;
    if (document.getElementById(id).checked === true) {
 
    this.props.parentVacationGoverCallback(value,"value");
     console.log(value)
    }
    else if(document.getElementById(id).checked === false){ 
      this.props.parentVacationGoverCallback(value,"flag");
    }
  
    
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;

      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getProfiledLocationData?collection=district&id=${id}`;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          `/core/user/rest/general/getProfiledLocationData?collection=district&id=${id}`;
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        if (res.data.result.data !== undefined) {
          if (value === "Ajlun") {
            this.setState({ Ajlun: res.data.result.data });
          } else if (value === "Amman") {
            this.setState({ Amman: res.data.result.data });
          } else if (value === "Amman") {
            this.setState({ Amman: res.data.result.data });
          } else if (value === "Aqaba") {
            this.setState({ Aqaba: res.data.result.data });
          } else if (value === "Balqa") {
            this.setState({ Balqa: res.data.result.data });
          } else if (value === "Irbid") {
            this.setState({ Irbid: res.data.result.data });
          } else if (value === "Jarash") {
            this.setState({ Jarash: res.data.result.data });
          } else if (value === "Karak") {
            this.setState({ Karak: res.data.result.data });
          } else if (value === "Ma'an") {
            this.setState({ Maan: res.data.result.data });
          } else if (value === "Madaba") {
            this.setState({ Madaba: res.data.result.data });
          } else if (value === "Mafraq") {
            this.setState({ Mafraq: res.data.result.data });
          } else if (value === "Tafiela") {
            this.setState({ Tafiela: res.data.result.data });
          } else if (value === "Zarqa") {
            this.setState({ Zarqa: res.data.result.data });
          }
        }
      });    
    
  };

  
  addDistrict =(event) =>{
    var id = event.target.id
    var value = event.target.value
     if (document.getElementById(id).checked === true) {
 
      this.props.parentVacationDistrictCallback(value,"value");
      console.log(value)
  
      }
      else if(document.getElementById(id).checked === false){
       
        this.props.parentVacationDistrictCallback(value,"flag");
      }
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;

    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getProfiledLocationData?collection=profiled_area&id=${id}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getProfiledLocationData?collection=profiled_area&id=${id}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.data !== undefined) {
        this.setState({ Areas: res.data.result.data });
  
      }


    });
  }

 
ShowArea(name,id){
 
  //if(this.state.areas.length>0){
    this.setState({
      visible:true,
      AreaName:name
    }) 
  //}

    
  
}

addArea =(value)=>{

  if(this.state.areas.includes(value)===false){
    this.state.areas.push(value)
    this.props.parentVacationAreaCallback(value,"value");
    
  } 

}

removeArea =(value)=>{
  if(this.state.areas.includes(value)===true){
    this.props.parentVacationAreaCallback(value,"flag");
  }
  
}
  render() {
    return (
      <div style={{ paddingLeft: "10px" }}>
        <Header as="h4" color="grey" dividing>
          <Icon name="map marker" />
            Weekend Location Categories{" "}
        </Header>

        <div className="row" style={{ width: "95%",paddingLeft:'10px' }}>
          {this.state.Cities.map((city, index) => (
            <div
              key={index}
              className="GoverStyle col-lg-4"
              style={{ marginBottom: "10px", textAlign: "center" }}
            >
              <Checkbox
                id={city.id}
                value={city.name}
                onClick={(event) => {
                  this.addGover(event);
                }}
                defaultChecked={false}
              />

              <Button.Group
                basic
                size="mini"
                className="square"
                value={city.name}
              >
                <Button
                  value={city.name}
                  content={city.name}
                  value={city.name}
                  style={{fontSize:'medium',fontWeight:'bold',padding:'1px'}}
                />
                <Button
                  icon="add"
                  value={city.name}
                  onClick={() => {
                    this.toggleVisibility(city.name);
                  }}
                />
                <Button
                  icon="minus"
                  value={city.name}
                  onClick={() => {
                    this.toggleVisibility(city.name);
                  }}
                />
              </Button.Group>
            </div>
          ))}
        </div>

        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            width: "100%",
            marginTop: "30px",
            
          }}
        >
           <Transition
            visible={this.state.visibleAjlun}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Ajlun Districts{" "}
                </Label>
                
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Ajlun.map((district, index) => (
                    <div
                      key={index}
                      className="GoverStyle col-lg-4"
                      style={{ marginBottom: "10px", textAlign: "center" }}
                    >
                      <Checkbox
                        id={district.id}
                        value={district.name}
                        onClick={(event) => {
                         this.addDistrict(event);
                        }}
                      />

       
                           <Button.Group
                       basic
                       size="mini"
                       style={{ marginLeft: "20px" }}
                     >
                       <Button
                         value={district.name}
                         content={district.name}
                        
                         style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                       />
                      <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false})}} />
                      </Button.Group>
                    </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

        
          <Transition
            visible={this.state.visibleAmman}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Amman Districts{" "}
                </Label>
                
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Amman.map((district, index) => (
                    <div
                      key={index}
                      className="GoverStyle col-lg-4"
                      style={{ marginBottom: "10px", textAlign: "center" }}
                    >
                      <Checkbox
                        id={district.id}
                        value={district.name}
                        onClick={(event) => {
                         this.addDistrict(event);
                        }}
                      />

                      <Button.Group
                        basic
                        size="mini"
                        style={{ marginLeft: "20px" }}
                      >
                        <Button
                          value={district.name}
                          content={district.name}
                          style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                        />
                      <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false})}} />
                      </Button.Group>
                    </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

         
             

             

          <Transition
            visible={this.state.visibleAqaba}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Aqaba Districts{" "}
                </Label>
               
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Aqaba.map((district, index) => (
                     <div
                     key={index}
                     className="GoverStyle col-lg-4"
                     style={{ marginBottom: "10px", textAlign: "center" }}
                   >
                     <Checkbox
                       id={district.id}
                       value={district.name}
                       onClick={(event) => {
                        this.addDistrict(event);
                       }}
                     />

                     <Button.Group
                       basic
                       size="mini"
                       style={{ marginLeft: "20px" }}
                     >
                       <Button
                         value={district.name}
                         content={district.name}
                         style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                       />
                      <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false})}} />
                     </Button.Group>
                   </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

         
              

          <Transition
            visible={this.state.visibleBalqa}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Balqa Districts{" "}
                </Label>
              
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Balqa.map((district, index) => (
                    <div
                    key={index}
                    className="GoverStyle col-lg-4"
                    style={{ marginBottom: "10px", textAlign: "center" }}
                  >
                    <Checkbox
                      id={district.id}
                      value={district.name}
                      onClick={(event) => {
                       this.addDistrict(event);
                      }}
                    />

                    <Button.Group
                      basic
                      size="mini"
                      style={{ marginLeft: "20px" }}
                    >
                      <Button
                        value={district.name}
                        content={district.name}
                        style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                      />
                      <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false})}} />
                    </Button.Group>
                  </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

         
              

          <Transition
            visible={this.state.visibleIrbid}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary  >
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Irbid Districts{" "}
                </Label>
               
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Irbid.map((district, index) => (
                     <div
                     key={index}
                     className="GoverStyle col-lg-4"
                     style={{ marginBottom: "10px", textAlign: "center" }}
                   >
                     <Checkbox
                       id={district.id}
                       value={district.name}
                       onClick={(event) => {
                        this.addDistrict(event);
                       }}
                     />

                     <Button.Group
                       basic
                       size="mini"
                       style={{ marginLeft: "20px" }}
                     >
                       <Button
                         value={district.name}
                         content={district.name}
                         style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                       />
                       <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false})}} />
                     </Button.Group>
                   </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>
         

          <Transition
            visible={this.state.visibleJarash}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Jarash Districts{" "}
                </Label>
               
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Jarash.map((district, index) => (
                     <div
                     key={index}
                     className="GoverStyle col-lg-4"
                     style={{ marginBottom: "10px", textAlign: "center" }}
                   >
                     <Checkbox
                       id={district.id}
                       value={district.name}
                       onClick={(event) => {
                        this.addDistrict(event);
                       }}
                     />

                     <Button.Group
                       basic
                       size="mini"
                       style={{ marginLeft: "20px" }}
                     >
                       <Button
                         value={district.name}
                         content={district.name}
                         style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                       />
                        <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false}) }} />
                     </Button.Group>
                   </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

          
          <Transition
            visible={this.state.visibleKarak}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Karak Districts{" "}
                </Label>
               
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Karak.map((district, index) => (
                     <div
                     key={index}
                     className="GoverStyle col-lg-4"
                     style={{ marginBottom: "10px", textAlign: "center" }}
                   >
                     <Checkbox
                       id={district.id}
                       value={district.name}
                       onClick={(event) => {
                        this.addDistrict(event);
                       }}
                     />

                     <Button.Group
                       basic
                       size="mini"
                       style={{ marginLeft: "20px" }}
                     >
                       <Button
                         value={district.name}
                         content={district.name}
                         style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                       />
                       <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false}) }} />
                     </Button.Group>
                   </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

         
              

               

          <Transition
            visible={this.state.visibleMaan}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Ma'an Districts{" "}
                </Label>
               
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Maan.map((district, index) => (
                     <div
                     key={index}
                     className="GoverStyle col-lg-4"
                     style={{ marginBottom: "10px", textAlign: "center" }}
                   >
                     <Checkbox
                       id={district.id}
                       value={district.name}
                       onClick={(event) => {
                        this.addDistrict(event);
                       }}
                     />

                     <Button.Group
                       basic
                       size="mini"
                       style={{ marginLeft: "20px" }}
                     >
                       <Button
                         value={district.name}
                         content={district.name}
                         style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                       />
                       <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false}) }} />
                     </Button.Group>
                   </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

       
              
                


          <Transition
            visible={this.state.visibleMadaba}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Madaba Districts
                </Label>
               
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Madaba.map((district, index) => (
                    <div
                    key={index}
                    className="GoverStyle col-lg-4"
                    style={{ marginBottom: "10px", textAlign: "center" }}
                  >
                    <Checkbox
                      id={district.id}
                      value={district.name}
                      onClick={(event) => {
                       this.addDistrict(event);
                      }}
                    />

                    <Button.Group
                      basic
                      size="mini"
                      style={{ marginLeft: "20px" }}
                    >
                      <Button
                        value={district.name}
                        content={district.name}
                        style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                      />
                      <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false}) }} />
                    </Button.Group>
                  </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

          
             

          <Transition
            visible={this.state.visibleMafraq}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Mafraq Districts{" "}
                </Label>
                
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Mafraq.map((district, index) => (
                  <div
                  key={index}
                  className="GoverStyle col-lg-4"
                  style={{ marginBottom: "10px", textAlign: "center" }}
                >
                  <Checkbox
                    id={district.id}
                    value={district.name}
                    onClick={(event) => {
                     this.addDistrict(event);
                    }}
                  />

                  <Button.Group
                    basic
                    size="mini"
                    style={{ marginLeft: "20px" }}
                  >
                    <Button
                      value={district.name}
                      content={district.name}
                      style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                    />
                   <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false}) }} />
                  </Button.Group>
                </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

         
              
                

          <Transition
            visible={this.state.visibleTafiela}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Tafiela Districts{" "}
                </Label>
               
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Tafiela.map((district, index) => (
                    <div
                    key={index}
                    className="GoverStyle col-lg-4"
                    style={{ marginBottom: "10px", textAlign: "center" }}
                  >
                    <Checkbox
                      id={district.id}
                      value={district.name}
                      onClick={(event) => {
                       this.addDistrict(event);
                      }}
                    />

                    <Button.Group
                      basic
                      size="mini"
                      style={{ marginLeft: "20px" }}
                    >
                      <Button
                        value={district.name}
                        content={district.name}
                        style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                      />
                      <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false}) }} />
                    </Button.Group>
                  </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

          
               

          <Transition
            visible={this.state.visibleZarqa}
            animation="scale"
            duration={500}
          >
            <div>
              <Segment secondary>
                {" "}
                <Label as="a" color="teal" ribbon>
                  {" "}
                  Zarqa Districts{" "}
                </Label>
               
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Zarqa.map((district, index) => (
                    <div
                    key={index}
                    className="GoverStyle col-lg-4"
                    style={{ marginBottom: "10px", textAlign: "center" }}
                  >
                    <Checkbox
                      id={district.id}
                      value={district.name}
                      onClick={(event) => {
                       this.addDistrict(event);
                      }}
                    />

                    <Button.Group
                      basic
                      size="mini"
                      style={{ marginLeft: "20px" }}
                    >
                      <Button
                        value={district.name}
                        content={district.name}
                        style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}}
                      />
                      <Button icon="add" value={district.name} onClick={()=>{this.ShowArea(district.name,district.id)}} />
                        <Button icon="minus" value={district.name} onClick={()=>{this.setState({visible:false}) }} />
                    </Button.Group>
                  </div>
                  ))}
                </div>
              </Segment>
              <br />
            </div>
          </Transition>

          
               
          <Transition
                visible={this.state.visible}
                animation="scale"
                duration={500}
              
              > 
          
              <Segment secondary style={{marginLeft:'30px'}}>
                {" "}
                <Label as="a" basic color="teal" ribbon >
                  {" "}
                 {this.state.AreaName}{" "} Areas 
                </Label>
                <br />
                <div
                  className="row"
                  style={{ width: "95%", marginTop: "10px" }}
                >
                  {this.state.Areas.map((area, index) => (
                    <div
                      key={index}
                      className="GoverStyle col-lg-4"
                      style={{ marginBottom: "10px",}}
                      id={area.name}
                    >
                     
                      <Button.Group basic size="mini" style={{marginLeft:'20px'}}>
                        <Button value={area.name} content={area.name} style={{fontSize:'medium',fontWeight:'bold',padding:'1px',width:'100px'}} />
                        <Button icon="add" value={area.name} onClick={()=>{this.addArea(area.name)}} />
                        <Button icon="minus" value={area.name} onClick={()=>{this.removeArea(area.name)}} />
                      </Button.Group>
                    </div>
                  ))}
                </div>
              </Segment>
              </Transition>



        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(VacationLocation);
